import { TranslateService } from '@ngx-translate/core';
import { Component, Input, OnInit, ViewEncapsulation, HostListener } from '@angular/core';
import { MemberService } from 'src/app/core/service/member.service';
import { sortBy, pad } from 'lodash';
@Component({
  selector: 'app-patient-summary-chart-well-being',
  templateUrl: './patient-summary-chart-well-being.component.html',
  styleUrls: ['./patient-summary-chart-well-being.component.scss'],
  encapsulation: ViewEncapsulation.None,
  styles: [`.k-chart-donut-center {
    background-color: #f5f6fb !important;
    color: #557288 !important;
  }`
  ]
})
export class PatientSummaryChartWellBeingComponent implements OnInit
{
  @Input() public memberId: number;

  public metricData = [];
  public metricDataAdjusted = [];
  public metricPages = [];
  public historyDialogOpened = false;
  public historyMetricName: string;
  public historyData: any[] = [];
  public selectedPage = 0;

  private riskScoreText: string;

  constructor(
    private memberService: MemberService,
    private translate: TranslateService) { }

  @HostListener('window:resize', ['$event'])
  public onResize(): void
  {
    this.changeScoreArray(window.innerWidth);
  }

  public ngOnInit(): void
  {
    this.getMemberRisks();
    this.translate.get('RISK-SCORES').subscribe({
      next: (value) =>
      {
        this.riskScoreText = value;
      }
    });
  }



  public getChartData(index: number): any
  {
    const data = [];
    data.push(this.metricData[index]);
    if (this.metricData[index].metricValue > 0)
    {
      for (let i = 0; i < 9; i++)
      {
        data.push({
          metricValue: this.metricData[index].metricValue,
          value: this.metricData[index].value,
          name: this.metricData[index].name,
          color: i < this.metricData[index].metricValue - 1 ? '#cf4526' : '#669146'
        });
      }
    }
    return data;
  }

  public openHistory(metric: any): void
  {
    this.memberService.getMemberRisksHistory(this.memberId, metric.serviceType.id).subscribe({
      next: (data) =>
      {
        this.historyMetricName = metric.name;
        this.historyData = [];
        const tempHistoryData = [];

        data.forEach(d =>
        {
          // Must take the most recent value for the day to render within the chart
          const foundIndex = tempHistoryData.findIndex(x =>
          {
            const date = new Date(d.createdOn);
            return date.getFullYear() === x.createdOn.getFullYear() &&
              date.getMonth() === x.createdOn.getMonth() &&
              date.getDate() === x.createdOn.getDate();
          });
          if (foundIndex === -1)
          {
            tempHistoryData.push(
              {
                value: d.score,
                createdOn: new Date(d.createdOn)
              });
          }
          else
          {
            tempHistoryData[foundIndex].value = d.score;
            tempHistoryData[foundIndex].createdOn = new Date(d.createdOn);
          }
        });
        this.historyData = tempHistoryData;
        this.historyDialogOpened = true;
      }
    });
  }

  public closeHistory(): void
  {
    this.historyDialogOpened = false;
  }

  public getRiskScoreTitle(): string
  {
    return this.riskScoreText;
  }

  public changePage(next: boolean): void
  {
    if (next)
    {
      if (this.selectedPage + 1 < this.metricPages.length)
      {
        this.selectedPage++;
      }
      else
      {
        this.selectedPage = 0;
      }
    }
    else
    {
      if (this.selectedPage - 1 < 0)
      {
        this.selectedPage = this.metricPages.length - 1;
      }
      else
      {
        this.selectedPage--;
      }
    }
  }

  private getMemberRisks(): void
  {
    this.memberService.getMemberRisks(this.memberId).subscribe({
      next: (risks) =>
      {
        risks.forEach(d =>
        {
          d.name = d.serviceType.displayName;
          d.sort = `${pad(d.score === null ? 99 : (d.score > 0 ? d.score : 80), 2, '0')}` + `-${d.name}`;
        });

        // Sort risks
        risks = sortBy(risks, ['sort']);

        /* Set metric data:
           1. Metric with null will show gray (not evaluated)
           2. Metric with 0 will show green (lowest risk)
           3. Metric from 1-10 will show in red. Where 1 is the lowest risk and 10 is the highest.
        */
        const metrics = [];
        risks.forEach(d =>
        {
          metrics.push({
            name: d.name,
            metricValue: d.score !== null ? d.score : 0,
            value: 1,
            color: d.score === null ? '#cccccc' : d.score === 0 ? '#669146' : '#cf4526',
            showHistory: d.score !== null,
            serviceType: d.serviceType
          });
        });
        this.metricData = metrics;
        this.changeScoreArray(window.innerWidth);
      }
    });
  }

  private changeScoreArray(innerWidth: number): void
  {
    this.metricDataAdjusted = [];
    this.metricPages = [];
    this.metricDataAdjusted = this.metricDataAdjusted.concat(this.metricData);
    let pages = 0;
    let size = 0;
    if (innerWidth >= 1200)
    {
      size = 8;
    }
    else if (innerWidth < 1200 && innerWidth >= 992)
    {
      size = 6;
    }
    else if (innerWidth < 992)
    {
      size = 4;
    }

    pages = Math.floor(this.metricData.length / size);
    for (let i = 0; i < pages; i++)
    {
      this.metricPages.push(this.metricDataAdjusted.splice(0, size));
    }
    if (this.metricData.length % size > 0)
    {
      this.metricPages.push(this.metricDataAdjusted.splice(0, this.metricData.length % size));
    }
    if (this.metricPages.length <= this.selectedPage)
    {
      this.selectedPage = this.metricPages.length - 1;
    }
  }
}
